import React, { memo } from "react";
import Box from "@mui/material/Box";
import Skeleton from "react-loading-skeleton";

import AppSkeletonTheme from "../../../components/skeletons/AppSkeletonTheme";

const SIDE = 40;

const PlantExplorerSearchSkeleton: React.FC = () => (
  <AppSkeletonTheme borderRadius="12px">
    <Box
      sx={{
        bgcolor: "#fff",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 20,
          bgcolor: "#fff",
          px: 2,
          pt: "calc(10px + env(safe-area-inset-top, 0px))",
          pb: "10px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: SIDE,
          }}
        >
          <Skeleton circle width={SIDE} height={SIDE} />
          <Box
            sx={{
              flex: 1,
              px: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: SIDE,
            }}
          >
            <Skeleton width="72%" height={16} />
          </Box>
          <Box sx={{ width: SIDE, flexShrink: 0 }} aria-hidden />
        </Box>
      </Box>

      <Box sx={{ px: 2, pt: 2, pb: 1 }}>
        <Skeleton height={40} borderRadius={999} />
      </Box>

      <Box sx={{ px: 2, pt: 0.5 }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <Skeleton
            key={i}
            height={52}
            borderRadius={10}
            style={{ marginBottom: 10 }}
          />
        ))}
      </Box>
    </Box>
  </AppSkeletonTheme>
);

export default memo(PlantExplorerSearchSkeleton);
